import SEOHead from '@/components/SEOHead';
import HeroSection from '@/components/home/HeroSection';
import StatsSection from '@/components/home/StatsSection';
import ExpertiseSection from '@/components/home/ExpertiseSection';
import MediaMentionsSection from '@/components/home/MediaMentionsSection';
import FeaturedLecturesSection from '@/components/home/FeaturedLecturesSection';
import BookPreviewSection from '@/components/home/BookPreviewSection';
import PartnersSlider from '@/components/home/PartnersSlider';
import CertificatesHighlights from '@/components/home/CertificatesHighlights';
import GalleryPreview from '@/components/home/GalleryPreview';

const Index = () => {
  return (
    <>
      <SEOHead
        title={{ he: 'אמיר עאסי — יועץ אסטרטגי, מרצה ומנהל בכיר', ar: 'أمير عاصي — مستشار استراتيجي ومحاضر', en: 'Amir Assi — Strategic Consultant & Lecturer' }}
        description={{ he: 'אמיר עאסי בעל ניסיון של למעלה מ-15 שנה בזירה העסקית, הציבורית והתקשורתית. דירקטור המתמחה בחברה הערבית.', ar: 'أمير عاصي يمتلك خبرة تزيد عن 15 عامًا في الساحة التجارية والعامة والإعلامية.', en: 'Amir Assi brings over 15 years of experience in business, public, and media arenas.' }}
        path=""
        type="profile"
      />
      <HeroSection />
      <StatsSection />
      <ExpertiseSection />
      <MediaMentionsSection />
      <PartnersSlider />
      <CertificatesHighlights />
      <GalleryPreview />
      <FeaturedLecturesSection />
      <BookPreviewSection />
    </>
  );
};

export default Index;
